import { getContractAddresses } from '@ui/config/base';
import { VenoSDK } from '@veno-app/sdk';
import { currentWallet, getNetworkConfig } from '@veno-app/wallet';
import type { ReactNode } from 'react';
import { createContext, memo, useContext, useEffect, useRef } from 'react';

export const VenoSDKContext = createContext<VenoSDK>(
  // we ensure this is always set in the provider
  null as unknown as VenoSDK,
);

interface TectonicSdkProviderProps {
  children: ReactNode;
}

const config = getNetworkConfig();

function VenoSDKProvider({ children }: TectonicSdkProviderProps): JSX.Element {
  const { useProvider } = currentWallet;
  const web3Provider = useProvider();

  const ref = useRef<VenoSDK>(
    (() => {
      const _sdk = new VenoSDK(getContractAddresses());
      _sdk.initWithRpc(config.rpcUrls[0], false);
      return _sdk;
    })(),
  );

  useEffect(() => {
    async function initSdk() {
      try {
        if (web3Provider) {
          ref.current.initWithProvider(web3Provider);
        } else {
          ref.current.initWithRpc(config.rpcUrls[0], false);
        }
      } catch (error) {
        console.error(error);
      }
    }

    initSdk();
  }, [web3Provider]);

  return (
    <VenoSDKContext.Provider value={ref.current}>
      {children}
    </VenoSDKContext.Provider>
  );
}

export function useVenoSDK() {
  return useContext(VenoSDKContext);
}

export default memo(VenoSDKProvider);
